import { forwardRef } from "react";
import type { LucideIcon } from "@/icons/lucide-compat";
import { cn } from "@openreel/ui";
import {
  FOCUS_RING,
  PILL_BASE,
  PILL_DARK,
  PILL_LIGHT,
  PILL_MOTION,
} from "./surface";

export interface OnboardingChipProps {
  label: string;
  icon: LucideIcon;
  selected: boolean;
  onSelect: () => void;
  /** Roving tabindex: only the focused chip in a group is tabbable. */
  tabIndex?: number;
}

export const OnboardingChip = forwardRef<HTMLButtonElement, OnboardingChipProps>(
  function OnboardingChip(
    { label, icon: Icon, selected, onSelect, tabIndex = 0 },
    ref,
  ) {
    return (
      <button
        ref={ref}
        type="button"
        // Marks the element for the wizard's global Enter handler, which must
        // leave Enter to the chip when a chip has focus.
        data-onboarding-chip=""
        aria-pressed={selected}
        tabIndex={tabIndex}
        onClick={onSelect}
        className={cn(
          PILL_BASE,
          PILL_MOTION,
          FOCUS_RING,
          selected ? PILL_LIGHT : PILL_DARK,
        )}
      >
        <Icon size={16} strokeWidth={1.5} aria-hidden />
        <span>{label}</span>
      </button>
    );
  },
);
